import { render, staticRenderFns } from "./PgaCertificationDetailsAccessibility.vue?vue&type=template&id=a45eabb8&scoped=true&"
import script from "./PgaCertificationDetailsAccessibility.vue?vue&type=script&lang=ts&"
export * from "./PgaCertificationDetailsAccessibility.vue?vue&type=script&lang=ts&"
import style0 from "./PgaCertificationDetailsAccessibility.vue?vue&type=style&index=0&id=a45eabb8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45eabb8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a45eabb8')) {
      api.createRecord('a45eabb8', component.options)
    } else {
      api.reload('a45eabb8', component.options)
    }
    module.hot.accept("./PgaCertificationDetailsAccessibility.vue?vue&type=template&id=a45eabb8&scoped=true&", function () {
      api.rerender('a45eabb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Resource/Certifications/Accessibility/PgaCertificationDetailsAccessibility.vue"
export default component.exports